(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookVersionSearch', HandbookVersionSearch);

    HandbookVersionSearch.$inject = ['$resource'];

    function HandbookVersionSearch($resource) {
        var resourceUrl =  'api/_search/handbook-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
